<template>
  <!--弹窗-->
  <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
    <el-form ref="formData" :model="formData" label-width="100px" size="mini">

        <template v-if="title=='负责人'">
            <el-form-item label="负责人">
                <el-input style="width: 300px;" type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="请输入负责人" v-model="formData.res_person_value" ></el-input>
            </el-form-item>
        </template>
        <template v-else>
            <el-form-item label="备注">
                <el-input style="width: 300px;" type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="请输入备注" v-model="formData.remark_value" ></el-input>
            </el-form-item>
        </template>
    </el-form>
    <el-row style="margin-top:17px; ">
      <el-button
        style="float:right;margin-left:6px;"
        size="mini"
        type="danger"
        plain
        @click="handleClose(true)"
      >取 消</el-button>
      <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import * as api from '@/api/Product/Product.js'
export default {
    data() {
        return {
            loading: false
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 保存信息
        submitForm() {
            this.loading = true;
            const tempFunc = this.title == '负责人' ? 'asin_update_res_person' : 'asin_update_remark'
            api[tempFunc](this.formData).then(res => {
                if (res.code === 0) {
                    this.$message({
                        message: "修改成功",
                        type: "success"
                    });
                    this.handleClose(false);
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
